/*
 * @Author: heyuan
 * @Date: 2020-08-19 16:41:57
 * @LastEditors: heyuan
 * @LastEditTime: 2020-08-19 17:44:26
 * @FilePath: \program-name\src\net\home\index.js
 */
import {get,post} from "../Api.js";
import config from "../config";
import {getCookie} from '../../untils/common.js'
import axios from 'axios'
const {communityUrl} = config

// 获取所有种草课程
function ApiGetCourse (params) {
  return get(`${communityUrl}/dynamic/course`, params);
}

// 获取所有种草课程
function ApiAddDynamic (params) {
  return post(`${communityUrl}/dynamic/addDynamic`, params);
}
export {
  ApiGetCourse,
  ApiAddDynamic
}



// WEBPACK FOOTER //
// ./src/net/community/index.js